import axios from 'axios';

import settings from '@/constants/constants';
import type { ProductOfferingResponse } from '@montugroup/circuit-shared';

const getProductOffering = (id: string) => axios.get<ProductOfferingResponse>(`${settings.url}/product/offering/${id}`);

export { getProductOffering };
